import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [NgFor, NgIf, DecimalPipe],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.css'
})
export class OrdersComponent implements OnChanges {
  @Input() firmId: any;
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  @Output() balancesLoaded = new EventEmitter<any[]>();

  isLoading = false;
  transactions: any[] = [];
  openingBalance = 0;
  ordersSummary = {
    title: 'Orders',
    total: 0,
  };

  summary = {
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 }
  };

  // accordion
  accordionState = {
    orders: true,
  };

  constructor(private accountService: AccountService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadOrders();
    }
  }

  loadOrders() {
    this.isLoading = true;
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.accountService.getDaybookCashflow(params).subscribe({
      next: (res: any) => {
        this.transactions = res.data.order_transactions || [];
        this.openingBalance = 0; // Or whatever represents opening balance for orders if applicable
        this.calculateSummary();
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading orders data', err);
        this.isLoading = false;
      }
    });
  }

  calculateSummary() {
    // Reset summary
    this.summary = {
      amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
      amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 }
    };

    this.transactions.forEach(t => {
      // Amount In
      if (t.cash > 0) this.summary.amount_in.cash += t.cash;
      if (t.bank > 0) this.summary.amount_in.bank += t.bank;
      if (t.card > 0) this.summary.amount_in.card += t.card;
      if (t.online > 0) this.summary.amount_in.online += t.online;
      this.summary.amount_in.disc += (t.disc || 0);

      // Amount Out
      if (t.cash < 0) this.summary.amount_out.cash += Math.abs(t.cash);
      if (t.bank < 0) this.summary.amount_out.bank += Math.abs(t.bank);
      if (t.card < 0) this.summary.amount_out.card += Math.abs(t.card);
      if (t.online < 0) this.summary.amount_out.online += Math.abs(t.online);
    });

    this.summary.amount_in.total = this.summary.amount_in.cash + this.summary.amount_in.bank + this.summary.amount_in.card + this.summary.amount_in.online;
    this.summary.amount_out.total = this.summary.amount_out.cash + this.summary.amount_out.bank + this.summary.amount_out.card + this.summary.amount_out.online;

    this.ordersSummary.total = this.summary.amount_in.total - this.summary.amount_out.total;
  }

  toggleAccordion(type: 'orders') {
    this.accordionState[type] = !this.accordionState[type];
  }

  getChips(trans: any) {
    return [
      { label: 'INV No.', value: trans.invoice_no },
      { label: 'Date', value: trans.date ? trans.date.split(' ')[0] : '' },
      { label: 'Firm', value: trans.firm },
      { label: 'UserName', value: trans.user },
      { label: 'City', value: trans.city },
      { label: 'Cash', value: trans.cash.toFixed(2) },
      { label: 'Bank', value: trans.bank.toFixed(2) },
      { label: 'Card', value: trans.card.toFixed(2) },
      { label: 'Online', value: trans.online.toFixed(2) },
      { label: 'Disc', value: trans.disc.toFixed(2) },
    ];
  }
}
